export default __webpack_public_path__ + "static/media/Leg_left.3239e57c.svg";